import React, { useRef, useState } from 'react'
import { getTargetForLink } from '../../../utility/get-target-for-link'
import { StyledMenuBaseLink, StyledMenuItemPanel, StyledMenuLink, StyledPoster, StyledSubMenu, StyledSubMenuItem, StyledSubSubMenu } from '../styled'
import { getViewport } from '../../../utility/get-viewport'

export const MenuItemPanel = props => {
  const postersToShow = props.posters.slice(0, props.defaultLinks && props.defaultLinks.length > 0 ? 1 : 2)
  const [hoverOn, setHoverOn] = useState(null)
  const mouseLeaveTout = useRef(null)

  const onMouseEnterHandler = (link) => (e) => {
    clearTimeout(mouseLeaveTout.current)
    let tout = null
    const removeTout = () => {
      clearTimeout(tout)
    }
    const target = e.target
    tout = setTimeout(() => {
      target.removeEventListener('mouseout', removeTout)
      setHoverOn(link)
    }, 300)
    target.addEventListener('mouseout', removeTout)
  }

  const onMouseLeaveHandler = () => {
    clearTimeout(mouseLeaveTout.current)
    mouseLeaveTout.current = setTimeout(() => {
      setHoverOn(null)
    }, 500)
  }

  return (
    <StyledMenuItemPanel>
      <StyledSubMenu>
        {props.links.map(link => (
          <li key={link.href}>
            <StyledSubMenuItem
              onMouseEnter={onMouseEnterHandler(link.name)}
              onMouseLeave={onMouseLeaveHandler}
              $hover={hoverOn === link.name}
              $hasSubMenu={link.links}
            >
              <StyledMenuLink to={link.href} target={getTargetForLink(link.href)}>{link.name}</StyledMenuLink>
              {link.links && link.links.length > 0 && (
                <StyledSubSubMenu>
                  {link.links.map(subLink => (
                    <li key={subLink.href}>
                      <StyledMenuLink to={subLink.href}>
                        {subLink.name}
                      </StyledMenuLink>
                    </li>
                  ))}
                </StyledSubSubMenu>
              )}
            </StyledSubMenuItem>
          </li>
        ))}
      </StyledSubMenu>
      {props.defaultLinks && props.defaultLinks.length > 0  && (
        <StyledSubMenu>
          {props.defaultLinks.map(link => (
            <li key={link.href}>
              <StyledMenuBaseLink href={link.href} target={getTargetForLink(link.href)}>
                {link.name}
              </StyledMenuBaseLink>
            </li>
          ))}
        </StyledSubMenu>
      )}
      {postersToShow.map(poster => (
        <StyledPoster to={poster.href} key={poster.href} target={getTargetForLink(poster.href)}>
          <img src={getViewport(poster.image[0].downloadURL, "xs")} alt={poster.image[0].ref} />
          <p className="link-secondary">{poster.name}</p>
        </StyledPoster>
      ))}
    </StyledMenuItemPanel>
  )
}